import { createRouter, createWebHistory } from '@ionic/vue-router';
import { RouteRecordRaw } from 'vue-router';
import Index from '../views/Home/IndexPage.vue';
import Login from '../views/Account/LoginPage.vue';
import TaskList from '../views/Task/TaskList.vue';
import CreateTask from '../views/Task/CreateTask.vue';
import CreateTaskFolder from '../views/Task/CreateTaskFolder.vue';
import TaskWorkList from '../views/Task/TaskWorkList.vue';
import CreateTaskWork from '../views/Task/CreateTaskWork.vue';
import EditTask from '../views/Task/EditTask.vue';
import EditTaskWork from '../views/Task/EditTaskWork.vue';
import TaskCloseRequestList from '../views/Task/TaskCloseRequestList.vue';
import CloseTask from '../views/Task/CloseTask.vue';
import OrgUnitReportDetails from '../views/Report/OrgUnitReportDetails.vue';
import OtherWorkList from '../views/OtherWork/OtherWorkList.vue';
import CreateOtherWork from '../views/OtherWork/CreateOtherWork.vue';
import EditOtherWork from '../views/OtherWork/EditOtherWork.vue';
import ReminderList from '../views/Reminder/ReminderList.vue';
import CreateReminder from '../views/Reminder/CreateReminder.vue';
import EditReminder from '../views/Reminder/EditReminder.vue';
import About from '../views/Home/AboutPage.vue';
import PrivacyPolicy from '../views/Home/PrivacyPolicyPage.vue';
import SmsRecharge from '../views/Home/SmsRecharge.vue';
import NoticeMassageUserList from '../views/Home/NoticeMassageUserList.vue';
import NoticeMassageUser from '../views/Home/NoticeMassageUser.vue';
import NoticeMassageUserEdit from '../views/Home/NoticeMassageUserEdit.vue';
import AppUpdate from '../views/Home/AppUpdatePage.vue';
import UpdatesPage from '../views/Home/UpdatesPage.vue';
import TimeLine from '../views/Task/TimeLine.vue';
import NotificationList from '../views/Account/NotificationList.vue';
import CreatePerson from '../views/Person/CreatePerson.vue';
import PersonList from '../views/Person/PersonList.vue';
import EditPerson from '../views/Person/EditPerson.vue';
import AddToHome from '../views/Home/AddToHome.vue';
import InviteUser from '../views/InviteUser/InviteUserListPage.vue';
import InviteUserPage from '../views/InviteUser/InviteUserPage.vue';
import ChangePass from '../views/Account/ChangePassword.vue';
import Expired from '../views/Account/ExpiredPage.vue';
import TaskTypeList from '../views/TaskType/TaskTypeList.vue';
import CreateTaskType from '../views/TaskType/CreateTaskType.vue';
import EditTaskType from '../views/TaskType/EditTaskType.vue';
import OtherWorkTypeList from '../views/OtherWorkType/OtherWorkTypeList.vue';
import CreateOtherWorkType from '../views/OtherWorkType/CreateOtherWorkType.vue';
import EditOtherWorkType from '../views/OtherWorkType/EditOtherWorkType.vue';
import OrgJobList from '../views/OrgJob/OrgJobList.vue';
import CreateOrgJob from '../views/OrgJob/CreateOrgJob.vue';
import EditOrgJob from '../views/OrgJob/EditOrgJob.vue';
import help from '../views/Home/HelpPage.vue';
import LocalUserList from '../views/LocalUserList/LocalUserList.vue';
import EditUser from '../views/LocalUserList/EditLocalUserList.vue';
import ForgotPass from '../views/Account/ForgotPassword.vue';
import TaskNoteList from '../views/TaskNote/TaskNoteList.vue';
import WorkTimerList from '../views/WorkTimer/WorkTimerList.vue';
import CreateTaskNote from '../views/TaskNote/CreateTaskNote.vue';
import EditTaskNote from '../views/TaskNote/EditTaskNote.vue';
import CheckList from '../views/CheckList/CheckList.vue';
import CreateCheckList from '../views/CheckList/CreateCheckList.vue';
import LandingPage from '../views/Home/LandingPage.vue';
import TaskOnlineOrder from '../views/TaskOnline/OrderPage.vue';
import TaskOnlineUserCreate from '../views/TaskOnline/CreateUser.vue';
import TaskOnlineUserOrder from '../views/TaskOnline/UserOrder.vue';
import Register from '../views/Account/RegisterPage.vue';
import UserPresenceList from '../views/UserPresence/UserPresenceList.vue';
import CreateUserPresence from '../views/UserPresence/CreateUserPresence.vue';
import EditUserPresence from '../views/UserPresence/EditUserPresence.vue';
import OrgUnitReport from '../views/Report/OrgUnitReport.vue';
import ValidateEmail from '../views/Account/ValidateEmail.vue';
import PinListPage from '../views/Home/PinListPage.vue';
import EditConversation from '../views/Conversation/EditConversation.vue';
import userProfile from '../views/Account/UserProfile.vue';
import showUsersOnMap from '../views/UserPresence/ShowUsersOnMap.vue';
import WorkGroupList from '../views/WorkGroup/WorkGroupListPage.vue';
import WorkGroupCreate from '../views/WorkGroup/WorkGroupCreate.vue';
import WorkGroupEdit from '../views/WorkGroup/WorkGroupEdit.vue';
import VacationList from '../views/Vacation/VacationListPage.vue';
import VacationCreate from '../views/Vacation/VacationCreate.vue';
import VacationEdit from '../views/Vacation/VacationEdit.vue';
import AddOrEditWorkTimer from '../views/WorkTimer/AddOrEditWorkTimer.vue';
const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        component: Index
    },

    {
        name: 'AddOrEditWorkTimer',
        path: '/AddOrEditWorkTimer/:id?',
        component: AddOrEditWorkTimer,
        meta: {
            editPage: true
        }
    },
    {
        name: 'VacationEdit',
        path: '/VacationEdit/:VacationId',
        component: VacationEdit,
        meta: {
            editPage: true
        }
    },
    {
        name: 'VacationList',
        path: '/VacationList',
        component: VacationList
    },
    {
        name: 'VacationCreate',
        path: '/VacationCreate',
        component: VacationCreate
    },
    {
        name: 'WorkGroupList',
        path: '/WorkGroupList',
        component: WorkGroupList
    },
    {
        name: 'WorkGroupCreate',
        path: '/WorkGroupCreate',
        component: WorkGroupCreate
    },
    {
        name: 'WorkGroupEdit',
        path: '/WorkGroupEdit/:WorkGroupId',
        component: WorkGroupEdit,
        meta: {
            editPage: true
        }
    },
    {
        name: 'login',
        path: '/login',
        component: Login
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: '/TaskList',
        component: TaskList,
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/CreateTask',
        component: CreateTask,
        meta: {
            editPage: true
        }
    },
    {
        name: 'CreateTaskFolder',
        path: '/CreateTaskFolder/:taskFolderId/:taskId',
        component: CreateTaskFolder
    },
    {
        name: 'TaskWorkList',
        path: '/TaskWorkList/:taskFolderId/:taskId',
        component: TaskWorkList
    },
    {
        name: 'CreateTaskWork',
        path: '/TaskWork/CreateTaskWork',
        component: CreateTaskWork,
        meta: {
            editPage: true
        }
    },
    {
        name: 'EditTask',
        path: '/Task/EidtTask/:taskId/:taskFolderId?',
        component: EditTask,
        meta: {
            keepAlive: false,
            editPage: true
        }
    },
    {
        name: 'EditTaskWork',
        path: '/TaskWork/EditTaskWork/:taskWorkId',
        component: EditTaskWork,
        meta: {
            editPage: true
        }
    },
    {
        name: 'TimeLine',
        path: '/TimeLine/:taskFolderId',
        component: TimeLine
    },
    {
        name: 'TaskCloseRequestList',
        path: '/TaskCloseRequestList',
        component: TaskCloseRequestList
    },
    {
        name: 'CloseTask',
        path: '/TaskCloseRequest/CloseTask/:closeRequestId',
        component: CloseTask
    },
    {
        name: 'OrgUnitReportDetails',
        path: '/Report/OrgUnitReportDetails/:orgCode/:status',
        component: OrgUnitReportDetails,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'OtherWorkList',
        path: '/OtherWorkList',
        component: OtherWorkList,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'CreateOtherWork',
        path: '/CreateOtherWork',
        component: CreateOtherWork,
        meta: {
            editPage: true
        }
    },
    {
        name: 'EditOtherWork',
        path: '/OtherWork/EditOtherWork/:otherWorkId',
        component: EditOtherWork,
        meta: {
            editPage: true
        }
    },
    {
        name: 'ReminderList',
        path: '/ReminderList',
        component: ReminderList,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'CreateReminder',
        path: '/CreateReminder/:taskId?',
        component: CreateReminder,
        meta: {
            editPage: true
        }
    },
    {
        name: 'EditReminder',
        path: '/Reminder/Details/:reminderId',
        component: EditReminder,
        meta: {
            editPage: true
        }
    },
    {
        name: 'About',
        path: '/About',
        component: About
    },
    {
        name: 'PrivacyPolicy',
        path: '/PrivacyPolicy',
        component: PrivacyPolicy
    },
    {
        name: 'SmsRecharge',
        path: '/SmsRecharge',
        component: SmsRecharge
    },
    {
        name: 'NoticeMassageUserList',
        path: '/NoticeMassageUserList',
        component: NoticeMassageUserList
    },
    {
        name: 'NoticeMassageUserEdit',
        path: '/NoticeMassageUserEdit/:NoticeMessageId',
        component: NoticeMassageUserEdit,
        meta: {
            editPage: true
        }
    },
    {
        name: 'NoticeMassageUser',
        path: '/NoticeMassageUser',
        component: NoticeMassageUser
    },
    {
        name: 'AppUpdate',
        path: '/AppUpdate',
        component: AppUpdate
    },
    {
        name: 'UpdatesPage',
        path: '/UpdatesPage',
        component: UpdatesPage
    },
    {
        name: 'PinListPage',
        path: '/PinList',
        component: PinListPage
    },
    {
        name: 'NotificationList',
        path: '/NotificationList',
        component: NotificationList
    },
    {
        name: 'CreatePerson',
        path: '/CreatePerson',
        component: CreatePerson,
        meta: {
            editPage: true
        }
    },
    {
        name: 'EditPerson',
        path: '/EditPerson/:personId',
        component: EditPerson,
        meta: {
            editPage: true
        }
    },
    {
        name: 'PersonList',
        path: '/PersonList',
        component: PersonList
    },
    {
        name: 'AddToHome',
        path: '/install',
        component: AddToHome
    },
    {
        name: 'ChangePass',
        path: '/ChangePass',
        component: ChangePass
    },
    {
        name: 'Expired',
        path: '/Expired/:adminOrUser',
        component: Expired
    },
    {
        name: 'TaskTypeList',
        path: '/TaskTypeList',
        component: TaskTypeList,

    },
    {
        name: 'CreateTaskType',
        path: '/CreateTaskType/:taskTypeId?',
        component: CreateTaskType
    },
    {
        name: 'EditTaskType',
        path: '/EditTaskType/:taskTypeId',
        component: EditTaskType
    },
    {
        name: 'OtherWorkTypeList',
        path: '/OtherWorkTypeList',
        component: OtherWorkTypeList,

    },
    {
        name: 'CreateOtherWorkType',
        path: '/CreateOtherWorkType',
        component: CreateOtherWorkType
    },
    {
        name: 'EditOtherWorkType',
        path: '/EditOtherWorkType/:otherWorkTypeId',
        component: EditOtherWorkType
    },
    {
        name: 'OrgJobList',
        path: '/OrgJobList',
        component: OrgJobList,

    },
    {
        name: 'CreateOrgJob',
        path: '/CreateOrgJob/:parentId',
        component: CreateOrgJob
    },
    {
        name: 'InviteUser',
        path: '/InviteUser',
        component: InviteUser
    },
    {
        name: 'InviteUserPage',
        path: '/InviteUserPage',
        component: InviteUserPage
    },
    {
        name: 'EditOrgJob',
        path: '/EditOrgJob/:orgJobId',
        component: EditOrgJob
    },
    {
        name: 'Help',
        path: '/Help',
        component: help
    },
    {
        name: 'LocalUserList',
        path: '/LocalUserList',
        component: LocalUserList
    },
    {
        name: 'EditUser',
        path: '/EditUser/:userId',
        component: EditUser
    },
    {
        name: 'ForgotPass',
        path: '/ForgotPass',
        component: ForgotPass
    },
    {
        name: 'TaskNoteList',
        path: '/TaskNoteList',
        component: TaskNoteList,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'CreateTaskNote',
        path: '/CreateTaskNote',
        component: CreateTaskNote,
        meta: {
            editPage: true
        }
    },
    {
        name: 'EditTaskNote',
        path: '/TaskNote/EditTaskNote/:noteId',
        component: EditTaskNote,
        meta: {
            editPage: true
        }
    },
    {
        name: 'CheckList',
        path: '/CheckList',
        component: CheckList,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'CreateCheckList',
        path: '/CreateCheckList/:checkListId?',
        component: CreateCheckList,
        meta: {
            editPage: true
        }
    },
    {
        name: 'LandingPage',
        path: '/LandingPage',
        component: LandingPage,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'Order',
        path: '/Order',
        component: TaskOnlineOrder,
        meta: {
            isOrder: true
        }
    },
    {
        name: 'CreateUser',
        path: '/CreateUser/:id?/:registByEmail?',
        component: TaskOnlineUserCreate,
        meta: {
            isOrder: true
        }
    },
    {
        name: 'UserOrder',
        path: '/UserOrder',
        component: TaskOnlineUserOrder,
        meta: {
            isOrder: true
        }
    },
    {
        name: 'UserPresenceList',
        path: '/UserPresenceList',
        component: UserPresenceList,
        meta: {
            keepAlive: true
        }
    },
    {
        name: 'CreateUserPresence',
        path: '/CreateUserPresence',
        component: CreateUserPresence,
        meta: {
            editPage: true
        }
    },
    {
        name: 'ShowUsersOnMap',
        path: '/ShowUsersOnMap',
        component: showUsersOnMap,
        meta: {
            keepAlive: false
        }
    },
    {
        name: 'EditUserPresence',
        path: '/EditUserPresence/:userPresenceId',
        component: EditUserPresence,
        meta: {
            editPage: true
        }
    },
    {
        name: 'OrgUnitReport',
        path: '/OrgUnitReport',
        component: OrgUnitReport
    },
    {
        name: 'ValidateEmail',
        path: '/ValidateEmail/:key/:mode',
        component: ValidateEmail,
        meta: {
            hasLayout: false
        }
    },
    {
        name: 'EditConversation',
        path: '/Conversation/EditConversation/:id',
        component: EditConversation,
        meta: {
            hasLayout: true
        }
    },
    {
        name: 'UserProfile',
        path: '/UserProfile',
        component: userProfile,
        meta: {
            hasLayout: true
        }
    },
    {
        name: 'WorkTimerList',
        path: '/WorkTimerList',
        component: WorkTimerList,

    }

]



const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            console.log("back to list:");
            console.log(to);
            console.log(savedPosition);
            return savedPosition;
        }

    },
})

export default router
